export default "__VITE_ASSET__BTPeDQa6__"